import ConstituentField from './ConstituentField';
import TemporaryField from './TemporaryField';

const CommonDefaults = Object.freeze({
  [ConstituentField.ATTACHMENTS]: [],
  [ConstituentField.AVATAR]: '',
  [ConstituentField.DISPLAY_NAME]: '',
  [ConstituentField.EMAILS]: [],
  [ConstituentField.PHONES]: [],
  [ConstituentField.ADDRESSES]: [],
  [ConstituentField.BIOGRAPHY]: '',
  [ConstituentField.CATEGORY_BOARD_MEMBER]: false,
  [ConstituentField.CATEGORY_MEMBER]: false,
  [ConstituentField.CATEGORY_PARTNER]: false,
  [ConstituentField.CATEGORY_RECIPIENT]: false,
  [ConstituentField.CATEGORY_VOLUNTEER]: false,
  [ConstituentField.CONSTITUENT_TYPE]: '',
  [ConstituentField.LABEL_IDS]: { tags: [] },
  [ConstituentField.WEBSITE]: '',
  [ConstituentField.INSTAGRAM]: '',
  [ConstituentField.TWITTER]: '',
  [ConstituentField.LINKEDIN]: '',
  [ConstituentField.FACEBOOK]: '',
  [ConstituentField.YOUTUBE]: '',
  [ConstituentField.TIKTOK]: '',
  [ConstituentField.NOTE_1]: '',
  [ConstituentField.NOTE_2]: '',
  [ConstituentField.NOTE_3]: '',
  [TemporaryField.LABELS]: [],
  [TemporaryField.UPLOAD_IDS]: [],
  [ConstituentField.IS_DONOR_RULESET]: false,
  [ConstituentField.IS_MAJOR_DONOR_RULESET]: false,
  [ConstituentField.IS_RECURRING_DONOR_RULESET]: false,
  [ConstituentField.CUSTOM_FIELDS]: {},
});

export default CommonDefaults;
